export const preventClickOnTextSelection=cb=>{return(...params)=>{const selection=window.getSelection();if("Range"!==selection.type)cb(...params)}};